<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields" foot-clone>
      <template #thead-top="data">
        <b-tr>
          <b-th colspan="3" style="text-align: center"></b-th>
          <b-th colspan="3" style="text-align: center">月缴费额</b-th>
        </b-tr>
      </template>
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>
      <template v-slot:cell(baseFee)="data">
        <div>{{ data.item.baseFee ? Number(data.item.baseFee).toFixed(2) : 0 }}</div>
      </template>
      <template v-slot:cell(gjjFeeDw)="data">
        <div>{{ data.item.gjjFeeDw ? Number(data.item.gjjFeeDw).toFixed(2) : 0 }}</div>
      </template>
      <template v-slot:cell(gjjFeeGe)="data">
        <div>{{ data.item.gjjFeeGe ? Number(data.item.gjjFeeGe).toFixed(2) : 0 }}</div>
      </template>
      <template v-slot:cell(gjjFee)="data">
        <div>{{ data.item.gjjFee ? Number(data.item.gjjFee).toFixed(2) : 0 }}</div>
      </template>

      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
      <template v-slot:foot()="scope">
        <div class="text-nowrap" :style="{textAlign:'center'}"></div>
      </template>
      <template v-slot:foot(index)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">合计</div>
      </template>
      <template v-slot:foot(baseFee)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'baseFee') }}</div>
      </template>
      <template v-slot:foot(gjjFeeDw)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'gjjFeeDw') }}</div>
      </template>
      <template v-slot:foot(gjjFeeGe)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'gjjFeeGe') }}</div>
      </template>
      <template v-slot:foot(gjjFee)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'gjjFee') }}</div>
      </template>
    </b-table>
  </div>
</template>

<script>
import {Decimal} from "decimal.js";
import moment from "moment";

export default {
  name: "HrSalaryCalcGjjDetail",
  data() {
    return {
      fields: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'employeeName', label: '员工姓名', width: '120px'},
        {key: 'baseFee', label: '月缴费基数', width: '120px'},
        {key: 'gjjFeeDw', label: '单位', width: '120px'},
        {key: 'gjjFeeGe', label: '个人', width: '120px'},
        {key: 'gjjFee', label: '小计', width: '120px'},
      ],
      items: [],
      columnLength: 0,
    }
  },
  created() {
    this.items = JSON.parse(this.$route.query.data)
    let adjustType = this.$route.query.adjustType
    if (adjustType === '2') {
      this.fields.splice(4, 1)
    } else if(adjustType === '1') {
      this.fields.splice(5, 1)
    }
  },
  methods: {
    init() {

    },
    goBack() {
      this.$router.back()
    },
    showDetail(content) {
      if (content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
    rowClass() {
      return 'row-center'
    },
    // 合计计算
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value));
        }
        return total
      }, new Decimal(0)).toFixed(2, Decimal.ROUND_HALF_UP);
    },
  }
}
</script>

<style scoped>
.row-center {
  display: flex;
  justify-content: center;
}
</style>
